import { PricingPlan, type PricingPlanGb } from "services/pricingPlan/pricingPlanTypes";

export const isGbPricingPlan = (pricingPlan: PricingPlan): pricingPlan is PricingPlanGb => {
  return [
    PricingPlan.JustRegister,
    PricingPlan.JustRegister2026,
    PricingPlan.FullFormation,
    PricingPlan.FullFormation19,
    PricingPlan.BusinessSecretary,
    PricingPlan.BusinessEssentials,
    PricingPlan.AllInOne,
    PricingPlan.Privacy,
    PricingPlan.LaunchPack,
    PricingPlan.SecretaryMonthly2025,
    PricingPlan.SecretaryYearly2025,
    PricingPlan.SecretaryPlusMonthly2025,
    PricingPlan.SecretaryPlusYearly2025,
    PricingPlan.TotalSupportMonthly2025,
    PricingPlan.TotalSupportYearly2025,
    PricingPlan.BlackFriday2025,
    PricingPlan.BusinessSupportYearly2026,
    PricingPlan.TotalSupportYearly2026,
    PricingPlan.BusinessLaunch2026,
    PricingPlan.BusinessLaunchChFee2026,
    PricingPlan.BusinessSupportChFeeYearly2026,
    PricingPlan.TotalSupportChFeeYearly2026,
    PricingPlan.SecretaryLite2026,
    PricingPlan.SecretaryYearly2026,
    PricingPlan.IntroducerFreeRegistration,
  ].includes(pricingPlan);
};
